import { render, staticRenderFns } from "./DashboardActionsBox.vue?vue&type=template&id=65f52f04&"
import script from "./DashboardActionsBox.vue?vue&type=script&lang=js&"
export * from "./DashboardActionsBox.vue?vue&type=script&lang=js&"
import style0 from "./DashboardActionsBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports